import React, {useEffect, useState} from 'react';
import {Box} from "@chakra-ui/layout";
import Logo from "../../utilities/Logo";
import {Button, FormControl, FormErrorMessage, FormLabel, Input, Link} from "@chakra-ui/react";
import {NavLink, useHistory} from "react-router-dom";
import {PASSWORDREGEX} from "../../../interfaces/Helper";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {teacherLogin} from "../../../action/teacherAction";
import {useSelector} from 'react-redux';

function TeacherLogin() {
  const history = useHistory();
  const dispatch = useStudentAuthDispatch();
  const {data: {role}} = useSelector((state: StateType) => state.rootReducer.teacherReducer)
  // form values
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  // errors
  const [errorUsername, setErrorUsername] = useState<string>("");
  const [errorPassword, setErrorPassword] = useState<string>("");
  // reveal password
  const [eyeStatus, setEyeStatus] = useState<boolean>(true);

  function revealPassword() {
    setEyeStatus(!eyeStatus);
  }

  async function submitForm(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    if (username === "") {
      return setErrorUsername("Please enter an username")
    }
    setErrorUsername("");
    if (password === "") {
      return setErrorPassword("Please enter a password")
    }
    setErrorPassword("");
    if (!PASSWORDREGEX.test(password)) {
      return setErrorPassword("Password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character");
    }
    setErrorPassword("")
    console.log("submit button clicked")
    const loginData = {username, password}
    await dispatch(teacherLogin(loginData));
  }

  useEffect(() => {
    if (role === "teacher") {
      history.push("/tutor/profile")
    }
  }, [role])

  return (
    <Box>
      <Logo _fontSize={"3rem"} _mt={8}/>
      <FormControl id="username" isRequired mt={"40px"} isInvalid={errorUsername !== ""}>
        <FormLabel fontSize={16} fontWeight={600}>Username</FormLabel>
        <Input type="text" autoFocus={true} placeholder="Enter your username" w={"clamp(150px, 80vw, 400px)"} required
               value={username}
               onChange={(e) => setUsername(e.target.value)}/>
        <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{errorUsername}</FormErrorMessage>
      </FormControl>
      <FormControl id="password" isRequired m={"20px 0"} isInvalid={errorPassword !== ""}>
        <FormLabel fontSize={16} fontWeight={600} textTransform={"capitalize"}>Password
          <Link as={NavLink} to={"/auth/student/signup"}
                float={"right"} color={"brand.gold"}>forgot password?
          </Link>
        </FormLabel>
        <Input id={"pwd"} type={`${eyeStatus ? "password" : "text"}`} placeholder="Enter your password" value={password}
               required
               w={"clamp(150px, 80vw, 400px)"} pos={"relative"}
               onChange={(e) => setPassword(e.target.value)}/>
        <Box pos={"absolute"} zIndex={"docked"} top={"40px"} right={"15px"} cursor={"pointer"}>
          <i className={`${eyeStatus ? "fas fa-eye" : "fas fa-eye-slash"}`} onClick={() => revealPassword()}/>
        </Box>
        <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{errorPassword}</FormErrorMessage>
      </FormControl>
      <Button type={"submit"} size="lg" textTransform={"capitalize"} fontSize={16} bgColor={"brand.darkGreen"}
              color={"brand.white"}
              display={"block"}
              w={"clamp(150px, 80vw, 400px)"} onClick={(e) => submitForm(e)}>login
      </Button>
      <br/>
      <Box textAlign={"center"}>
        <Link as={NavLink} to={"/auth/tutor/signup"} textAlign={"center"} fontSize={14} color={"brand.grey"}>
          Don't have an account? Sign Up
        </Link>
      </Box>
    </Box>
  );
}

export default TeacherLogin;